import { render } from "./SurfOutroView.vue?vue&type=template&id=61192112&scoped=true"
import script from "./SurfOutroView.vue?vue&type=script&lang=js"
export * from "./SurfOutroView.vue?vue&type=script&lang=js"

import "./SurfOutroView.vue?vue&type=style&index=0&id=61192112&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61192112"]])

export default __exports__